/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cook_Done_BackInputs */

const en_cook_done_back = /** @type {(inputs: Cook_Done_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to the recipe`)
};

const de_cook_done_back = /** @type {(inputs: Cook_Done_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Rezept`)
};

/**
* | output |
* | --- |
* | "Back to the recipe" |
*
* @param {Cook_Done_BackInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cook_done_back = /** @type {((inputs?: Cook_Done_BackInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cook_Done_BackInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cook_done_back(inputs)
	return en_cook_done_back(inputs)
});